import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface GuaranteeSummary {
	garantia: any[];
}

@Component({
	selector: 'guarantee-modal',
	templateUrl: './guarantee-modal.component.html',
	styleUrls: ['./guarantee-modal.component.scss']
})
export class GuaranteeSummaryModalComponent extends DialogComponent<GuaranteeSummary, boolean> implements GuaranteeSummary {
	garantia: any[];
	
	constructor(dialogService: DialogService) {
		super(dialogService);
	}

	confirm() {
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/summary/guarantee-modal/guarantee-modal.component.ts